// 软件版本号（前端展示用）
// 从 2.0 开始，用以区别于 Excel 宏版本的阿米巴软件。
// 后续升级只需修改此处的字符串即可。
export const APP_VERSION = '2.2.90';
